import { Button, Grid } from "@material-ui/core";
import React, { useState } from "react";
import { LSDBCoreTable } from "../../../../common/LSDBCoreTable";
import { TsdTravelerDialog } from "./TsdTravelerDialog";
import { generalFilter } from "../../../../../util/filter";


export const TsdTestSequenceDialog = ({ tsdData, handleClose }: any) => {


  const [selectedSerial, setSelectedSerial] = useState<string | null>(null);
  const [openRsdVirtualDialog, setOpenRsdVirtualDialog] = React.useState(false);

  const handleOpen = (id: string) => {
    setSelectedSerial(id);
    setOpenRsdVirtualDialog(!openRsdVirtualDialog);
  };
  
  


  const columns = React.useMemo(
    
    () => [
        

        {
        Header: "id",
        accessor: "id",
        filter: generalFilter,
        Cell: ({ row }: any) => (
          <Button
            variant="contained"
            color="primary"
            
            onClick={() => handleOpen(row.values.id)}
          >
            {row.values.id}
          </Button>
        )

      },
      
      {
        accessor: "name",
        id: "name",
        filter: generalFilter,
        Cell: ({ row }: any) => {
          return row.values.name === null ? (
            <p>N/A</p>
          ) : (
            <p>{row.values.name}</p>
          );
        }
      },

    ],
    []
  );

  return (
    <Grid
      container
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      spacing={4}
    >
      <Grid item xs={12}>
        <LSDBCoreTable columns={columns} data={tsdData} hiddenColumns={[""]} />
      </Grid>
      {selectedSerial && (
        <TsdTravelerDialog id={selectedSerial} travelerOpen={openRsdVirtualDialog} handleTraveler={handleOpen} handleClose={handleClose}  />
      )}
    </Grid>

  );

}